package team.platforma.multiplatform_material_extension.ui.flexbox

enum class FlexGravity {
    START,
    CENTER,
    END
}